"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GetTestIds = exports.CalculatorCardStyles = exports.CalculatorCard = void 0;
var _material = require("@mui/material");
var _CalculatorProvider = require("./CalculatorProvider");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _string = require("../../utils/type-checks/string");
var _styles = require("@mui/material/styles");
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const merge = require("deepmerge"),
  GetTestIds = seed => {
    return {
      after: (0, _string.isStringOfLength)(seed) ? `${seed}__card-after` : undefined,
      bottom: (0, _string.isStringOfLength)(seed) ? `${seed}__card-bottom` : undefined,
      content: (0, _string.isStringOfLength)(seed) ? `${seed}__card-content` : undefined,
      component: (0, _string.isStringOfLength)(seed) ? seed : undefined,
      icon: (0, _string.isStringOfLength)(seed) ? `${seed}__card-icon` : undefined,
      top: (0, _string.isStringOfLength)(seed) ? `${seed}__card-top` : undefined
    };
  },
  CalculatorCardStyles = theme => {
    return {};
  };

/**
 * Calculator Results Card Component
 *
 * @visibleName Calculator Results Card
 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
*/
exports.CalculatorCardStyles = CalculatorCardStyles;
exports.GetTestIds = GetTestIds;
const CalculatorCard = props => {
  const {
      afterCard,
      bottomContent,
      className,
      hideIcon = false,
      icon = "data:image/svg+xml;base64,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",
      iconAltText = "Calculator Icon",
      styles = {},
      testId,
      topContent
    } = props,
    compiledClasses = (0, _classnames.default)({
      "calculator__result--isCard": true,
      [`${className}`]: className
    }),
    testIdObj = GetTestIds(testId),
    compiledStyles = merge({
      bordrRadius: "0.5rem",
      boxShadow: "none",
      marginTop: {
        xs: "4rem",
        md: "0"
      },
      paddingTop: {
        xs: "4.8rem",
        md: "0"
      },
      position: "relative",
      overflow: "visible",
      transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
      width: "100%",
      ".calculator__result-card-icon": {
        alignItems: "center",
        display: "flex",
        borderRadius: "50%",
        height: "7.5rem",
        justifyContent: "center",
        left: "calc(50% - (7.5rem / 2))",
        position: "absolute",
        top: {
          xs: "0",
          md: "-4.8rem"
        },
        width: "7.5rem",
        zIndex: "2"
      },
      ".calculator__result-card-content": {
        borderRadius: "0.5rem",
        overflow: "hidden"
      }
    }, styles);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: compiledClasses,
    "data-testid": testIdObj.component,
    sx: compiledStyles
  }, !hideIcon && (0, _string.isStringOfLength)(icon) && /*#__PURE__*/_react.default.createElement(_material.Box, {
    alt: iconAltText,
    className: "calculator__result-card-icon",
    component: "img",
    "data-testid": testIdObj.icon,
    src: icon
  }), !hideIcon && !(0, _string.isStringOfLength)(icon) && /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "calculator__result-card-icon",
    "data-testid": testIdObj.icon
  }, icon), /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "calculator__result-card-content",
    "data-testid": testIdObj.content
  }, topContent && /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "calculator__result-card--isUpper",
    "data-testid": testIdObj.top
  }, topContent), bottomContent && /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "calculator__result-card--isLower",
    "data-testid": testIdObj.bottom
  }, bottomContent)), afterCard && /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "calculator__result-card--isAfterCard",
    "data-testid": testIdObj.after
  }, afterCard));
};

/**
 * Calculator Results Component
 *
 * @visibleName Calculator Results
 * @author [Jeff Stevens](mailto:jeffrey.stevens@pheaa.org)
*/
exports.CalculatorCard = CalculatorCard;
const CalculatorResults = props => {
  const {
      children,
      className,
      customTheme = {},
      genericTag = "div",
      styles = {},
      testId,
      variant,
      ...rest
    } = props,
    isGeneric = variant !== "card",
    theme = merge.all([(0, _styles.useTheme)(), _CalculatorProvider.Methods.useCustomTheme(), customTheme]),
    compiledClasses = (0, _classnames.default)({
      "calculator__result": true,
      "calculator__result--isGeneric": isGeneric,
      [`${className}`]: className
    }),
    compositeStyles = merge(CalculatorCardStyles(theme), styles);
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, variant === "card" && /*#__PURE__*/_react.default.createElement(CalculatorCard, _extends({
    className: compiledClasses,
    styles: compositeStyles,
    testId: testId
  }, rest)), isGeneric && children && /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: compiledClasses,
    component: genericTag,
    "data-testid": testId,
    sx: compositeStyles
  }, children));
};

// Define propTypes;
CalculatorResults.propTypes = {
  /** Content to appear after result card variant */
  afterCard: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  /** Content for bottom portion of result card variant */
  bottomContent: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  /** Child content for the generic variant result layout */
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  /** Optional class name(s) */
  className: _propTypes.default.string,
  /** Custom theme object (Default Value: {}) */
  customTheme: _propTypes.default.object,
  /** Tag to display generic variant content within (Default Value: "div") */
  genericTag: _propTypes.default.string,
  /** Boolean to hide/show card icon on result card variant */
  hideIcon: _propTypes.default.bool,
  /** Card Icon for result card variant (Default Value: Base64 SVG string) */
  icon: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  /** Icon image alt text for result card variant (Default Value: "Calculator Icon") */
  iconAltText: _propTypes.default.string,
  /** Custom styles object (Default Value: {}) */
  styles: _propTypes.default.object,
  /** @ignore */
  testId: _propTypes.default.string,
  /** Result variant */
  variant: _propTypes.default.oneOf(["card", "generic"]),
  /** Content for top portion of result card variant */
  topContent: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string])
};
CalculatorCard.propTypes = {
  /** Content to appear after result card */
  afterCard: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  /** Content for bottom portion of result card */
  bottomContent: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  /** Optional class name(s) */
  className: _propTypes.default.string,
  /** Boolean to hide/show card icon */
  hideIcon: _propTypes.default.bool,
  /** Card Icon */
  icon: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  /** Icon image alt text */
  iconAltText: _propTypes.default.string,
  /** Custom style object */
  styles: _propTypes.default.object,
  /** @ignore */
  testId: _propTypes.default.string,
  /** Content for top portion of result card */
  topContent: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string])
};

// Export component as default;
var _default = exports.default = CalculatorResults;